import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { AreaValidations } from '../../../../models';

import { LOCATION_TYPES } from '../../../../constants/areas';
import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import FormField from '../../formfield/FormField';

export class AreaFileForm extends Component {
  componentDidMount() {
    if (this.props.isOutdoor) {
      this.props.continue();
    }
  }
  render() {
    if (this.props.isOutdoor) {
      return false;
    }
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <Field
          name="file"
          type="file"
          component={FormField}
          dropzoneOptions={{
            accept: '.png',
            multiple: false,
            maxSize: 5242880
          }}
          validate={AreaValidations.file}
        />
        <FormActions>
          <Button>{I18n.t('add.add')}</Button>
        </FormActions>
      </AddForm>
    );
  }
}

const selector = formValueSelector('addarea');
const mapStateToProps = state => {
  return { isOutdoor: LOCATION_TYPES.OUTDOOR === selector(state, 'location') };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addarea',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(AreaFileForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/addareaform/areafileform/AreaFileForm.js